import { render, staticRenderFns } from "./channelRecord.vue?vue&type=template&id=c74827dc"
import script from "./channelRecord.vue?vue&type=script&lang=js"
export * from "./channelRecord.vue?vue&type=script&lang=js"
import style0 from "./channelRecord.vue?vue&type=style&index=0&id=c74827dc&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports